import { render, staticRenderFns } from "./PrintableReportResidents360Settings.vue?vue&type=template&id=44af4b78"
import script from "./PrintableReportResidents360Settings.ts?vue&type=script&lang=js&external"
export * from "./PrintableReportResidents360Settings.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports